import { z } from 'zod';
import { bindWebAuthnGuard } from '../interactions.js';
import { VerificationType } from './verification-type.js';
const baseWebAuthnVerificationRecordDataGuard = z.object({
    id: z.string(),
    verified: z.boolean(),
    registrationChallenge: z.string().optional(),
    registrationRpId: z.string().optional(),
    authenticationChallenge: z.string().optional(),
    registrationInfo: bindWebAuthnGuard.optional(),
});
export const webAuthnVerificationRecordDataGuard = baseWebAuthnVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.WebAuthn),
    userId: z.string(),
});
export const sanitizedWebAuthnVerificationRecordDataGuard = webAuthnVerificationRecordDataGuard.omit({
    registrationInfo: true,
    registrationChallenge: true,
    registrationRpId: true,
    authenticationChallenge: true,
});
export const signInWebAuthnVerificationRecordDataGuard = baseWebAuthnVerificationRecordDataGuard.extend({
    type: z.literal(VerificationType.SignInWebAuthn),
    userId: z.string().optional(),
    authenticationRpId: z.string().optional(),
});
export const sanitizedSignInWebAuthnVerificationRecordDataGuard = signInWebAuthnVerificationRecordDataGuard.omit({
    registrationInfo: true,
    registrationChallenge: true,
    registrationRpId: true,
    authenticationChallenge: true,
    authenticationRpId: true,
});
